<template>
  <mu-dialog width="80%" :open.sync="open" :esc-press-close="false" :overlay-close="false" >
    <div slot="title" style="width:100%">
      <span>Add New Repo</span>
      <mu-linear-progress v-if="loading"></mu-linear-progress>
    </div>

    <mu-text-field v-model="name" :disabled="loading" label="Repo Name" prefix="https://www.bitbucket.org/beehivecoltd/" full-width :error-text="errorMsg"></mu-text-field>

    <mu-button slot="actions" flat @click="close">cancel</mu-button>
    <mu-button slot="actions" flat color="primary" @click="save" :disabled="loading">Add</mu-button>
  </mu-dialog>
</template>

<script>
export default {
  name: 'DialogAddRepo',
  props: {
    open: Boolean,
  },
  data() {
    return {
      loading: false,
      name: "",
      errorMsg: ""
    }
  },
  created: function() {
  },
  mounted: function() {
  },
  methods: {
    close: function() {
      this.$emit('update:open', false);
    },
    save: function() {
      this.loading = true;

      if (this.name.length > 0) {
        this.$http.get('https://api.bitbucket.org/2.0/repositories/beehivecoltd/' + this.name + '/issues')
        .then(() => {
          this.errorMsg = "";
          this.$parent.addRepo(this.name);

          this.close();
        })
        .catch(e => {
          // this.errors.push(e)
          console.log(e.response.data.error)
          if (e.response.data.type === "error") {
            console.log(e.response.data.error.message)
            this.errorMsg = e.response.data.error.message;
          }
          else this.errorMsg = "พัง"
        })
        .then(() => this.loading = false)
      }

    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DialogAddRepo.vue